module.exports = __webpack_public_path__ + "img/red_072.1aaa5e6c.png";